export const DEFAULT_TIMEOUT = 0;

// Style overrides for react-portal-tooltip
export const TOOLTIP_STYLE = {
  style: {
    borderRadius: 0,
    boxShadow: '0px 1px 4px 2px rgba(0, 0, 0, 0.5)',
    padding: '5px',
    maxWidth: '300px',
    transition: 'opacity 0.2s ease-in-out',
    zIndex: '2147483647', // try getting in front of me now
  },
  arrowStyle: {},
};
